module.exports = require("./ar-IL.d.ts");